var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronCropped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 10,
    viewBox: "0 0 18 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.60286 8.89519L1.10286 1.39519C1.0035 1.28856 0.949406 1.14752 0.951977 1.0018C0.95455 0.85607 1.01358 0.717031 1.11664 0.613971C1.2197 0.510911 1.35874 0.451877 1.50447 0.449306C1.65019 0.446735 1.79123 0.500827 1.89786 0.600187L9.00036 7.70175L16.1029 0.600188C16.2095 0.500828 16.3505 0.446735 16.4963 0.449306C16.642 0.451878 16.781 0.510912 16.8841 0.613972C16.9871 0.717032 17.0462 0.856071 17.0487 1.0018C17.0513 1.14752 16.9972 1.28856 16.8979 1.39519L9.39786 8.89519C9.29239 9.00053 9.14942 9.05969 9.00036 9.05969C8.8513 9.05969 8.70833 9.00053 8.60286 8.89519Z",
    fill: "#404D6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronCropped);
export default __webpack_public_path__ + "static/media/chevron-cropped.b1d2e05d2de895506b0f955f5501c923.svg";
export { ForwardRef as ReactComponent };